<div class="eia-flex-and-center">
  <div class="eia-heatmap-legend-box">

    <div class="eia-heatmap-legend-text eia-side-margins-short">
      <div *ngFor="let topLabel of topLabels">{{topLabel}}</div>
    </div>

    <div class="eia-flex-and-center">
      <div *ngFor="let item of heatMapColors" class="eia-heatmap-legend-tile"
           [ngStyle]="{'background-color':item.color}">
      </div>
    </div>
    <div class="eia-flex-and-center align-base">
      <div *ngFor="let item of heatMapColors" [ngClass]="{'eia-heatmap-legend-tile':true, 'eia-legend-label':true}">
        <div class="legend-tile-label">
          <span *ngIf="item.lower">{{item.lower}}</span>
          <span *ngIf="item.upper && item.lower"> to </span>
          <span *ngIf="item.upper">{{item.upper}}</span>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/map-legend/map-legend.component.html